import type { RespostasEtapa1Candidato } from '../../models';
import { cpfValido } from '../../utils/masks';

export type EtapaCandidato = 'introducao' | 'dados_pessoais' | 'sobre_ia' | 'perfil_profissional' | 'autorizacao';

/** "Sobre IA" só entra se o recrutador marcou isso ao cadastrar o candidato (nem toda
 * vaga precisa) — ver AdicionarCandidatoModal/Candidato.perguntasSobreIA. */
export function montarEtapasCandidato(perguntasSobreIA: boolean): EtapaCandidato[] {
  const etapas: EtapaCandidato[] = ['introducao', 'dados_pessoais'];
  if (perguntasSobreIA) etapas.push('sobre_ia');
  etapas.push('perfil_profissional', 'autorizacao');
  return etapas;
}

const CAMPOS_POR_ETAPA: Partial<Record<EtapaCandidato, Array<keyof RespostasEtapa1Candidato>>> = {
  dados_pessoais: [
    'nomeCompleto',
    'dataNascimento',
    'rg',
    'cpf',
    'cidadeNascimento',
    'ufNascimento',
    'cidadeEstadoResidencia',
    'nomeMae',
    'nomePai',
  ],
  sobre_ia: ['sobreIaEtapas', 'sobreIaProcesso', 'sobreIaQualidade'],
  perfil_profissional: ['disponibilidadeInicio', 'pretensaoSalarial'],
};

/** "Introdução" sempre pode avançar; "Autorização" depende do checkbox, checado à parte. */
export function etapaEstaCompleta(etapa: EtapaCandidato, respostas: RespostasEtapa1Candidato): boolean {
  if (etapa === 'introducao') return true;
  if (etapa === 'autorizacao') return respostas.autorizacaoLgpd === true;
  const campos = CAMPOS_POR_ETAPA[etapa] ?? [];
  const preenchidos = campos.every((campo) => Boolean((respostas[campo] as string | null | undefined)?.trim()));
  // CPF errado travava só no envio final — melhor travar aqui, perto de onde a pessoa errou.
  if (etapa === 'dados_pessoais') return preenchidos && cpfValido(respostas.cpf);
  return preenchidos;
}
